export const acceptExt = {
  audio: ['audio/mp3', 'audio/wav', 'audio/mpeg'],
  video: ['video/mp4'],
  magazine: ['application/pdf'],
  image: ['image/jpeg', 'image/png', 'image/apng'],
}

// Safari/Firefox/IEの場合、mp3のmimeTypeはaudio/mpeg
export const hideAcceptTypes = ['audio/mpeg']

export const uploadFileSize = {
  image: 2 * 10 ** 6, // 2MB
  magazine: 20 * 10 ** 6, // 20MB
  audio: 200 * 10 ** 6, // 200MB
  video: 2 * 10 ** 9, // 2GB
}
